import React from 'react';
import styled from 'styled-components';
import { COLORS, Row } from '@cuemath/comps';
import { Text } from '@cuemath/web-comps';

import StudentTransferSlotsList from 'modules/drawers/student-transfer/slots-pending/add-slots';

const LinkText = styled(Text)`
  width: fit-content;
  border-bottom: 1px solid ${COLORS.COLA};
  line-height: 20px;
  text-align: center;
  cursor: pointer;
  transition: all 0.2s ease-in-out;

  :hover {
    border-bottom: 1px solid ${COLORS.WHITE};
  }
`;

const SlotDayTime = ({
  slotsList,
  updateSlotsList,
  addMoreSlots,
  setSlotsList,
  initState,
  title,
}) => {
  return (
    <>
      <Text variant="h6">{title || 'Select preferred date and time'}</Text>

      {slotsList?.map(slotData => {
        return (
          <StudentTransferSlotsList
            key={slotData.id}
            {...slotData}
            updateSlotsList={updateSlotsList}
            slotsList={slotsList}
          />
        );
      })}

      <Row justifyContent="space-between" alignItems="center">
        <LinkText variant="body1Regular" weight="600" onClick={addMoreSlots}>
          {slotsList?.length < 7 && 'Add more'}
        </LinkText>
        <LinkText
          variant="body1Regular"
          weight="600"
          onClick={() => setSlotsList(initState)}
        >
          Reset
        </LinkText>
      </Row>
    </>
  );
};

export default SlotDayTime;
